import {PhotoUploadButton} from '~/ViewInvitation/routes/Landing/PhotosModule/PhotoUploadButton';
import {Button} from '~library/atoms/Button';
import {Typography} from '~library/atoms/Typography';
import {TrashIcon} from '~library/svg/TrashIcon';
import {charcoal, coin} from '~libSass/base/_exports.sass';

interface PhotoGalleryEditorActionsProps {
  combinedPhotosLength: number;
  isLargishAndUp: boolean;
  isLoading: boolean;
  handleDeleteAllPhotos: () => void;
  fileUploadRef: React.RefObject<HTMLInputElement>;
  isHostModule: boolean;
}

export const PhotoGalleryEditorActions = ({
  combinedPhotosLength,
  isLargishAndUp,
  isLoading,
  handleDeleteAllPhotos,
  fileUploadRef,
  isHostModule,
}: PhotoGalleryEditorActionsProps) => (
  <div className="photo-editor__actions">
    {!!combinedPhotosLength && (
      <Button
        variant="secondary"
        size="medium"
        tight={!isLargishAndUp}
        data-qa-id="delete-all-photos"
        onClick={handleDeleteAllPhotos}
        disabled={isLoading}
        ariaLabel="delete all photos"
        icon={
          !isLargishAndUp ? <TrashIcon color={isLoading ? coin : charcoal} ratio={0.5} /> : null
        }
      >
        <Typography variant="paragraph2">{isLargishAndUp ? 'Delete all' : 'All'}</Typography>
      </Button>
    )}
    <PhotoUploadButton
      variant="secondary"
      fileUploadRef={fileUploadRef}
      disabled={isLoading}
      iconColor={charcoal}
      isHostModule={isHostModule}
    >
      <Typography variant="paragraph2">Add</Typography>
    </PhotoUploadButton>
  </div>
);
